import isEmpty from "../helpers/isEmpty";

class CategoryModel {
  constructor(data) {
    this.id = data.id || "";
    this.name = data.name || "";
  }

  static displayCategory(category) {
		if(!category || !category.id || !category.name) {
			return "";
		}
    return `<span  class="new_press_category_label read_more--red" data-tag-key="${category.id}">${category.name}</span>`;
  }
}

export default CategoryModel;
